import type { OptionDefinition } from "../types.ts";

/** Options used at runtime but not prominently in UI (or advanced) */
export const advancedOptions: OptionDefinition[] = [
  {
    key: "canvasVerticalAlignment",
    type: "select",
    default: "bottom",
    label: "Canvas Vertical Alignment",
    tab: "camera",
    hidden: true,
    options: [
      { value: "top", label: "Top" },
      { value: "bottom", label: "Bottom" },
      { value: "center", label: "Center" },
    ],
  },
  {
    key: "jitterCompensation",
    type: "range",
    default: 0,
    min: 0,
    max: 1,
    step: 0.1,
    label: "Jitter Compensation",
    tab: "camera",
    hidden: true,
  },
  {
    key: "jitterMissingDataTolerance",
    type: "range",
    default: 0,
    min: 0,
    max: 60,
    step: 1,
    label: "Jitter Missing Data Tolerance",
    tab: "camera",
    hidden: true,
  },
  {
    key: "scalarRendering1HandLeft",
    type: "boolean",
    default: false,
    label: "Scalar Rendering (1 Hand Left)",
    tab: "camera",
    dependsOn: "scalarControl",
    hidden: true,
  },
  {
    key: "scalarRendering1HandRight",
    type: "boolean",
    default: false,
    label: "Scalar Rendering (1 Hand Right)",
    tab: "camera",
    dependsOn: "scalarControl",
    hidden: true,
  },
];
